module.exports = __webpack_public_path__ + "static/img/Icononaranjo.344e9bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icononaranjo.png
// module id = mUTG
// module chunks = 38